export function urgency(days) {
  if (days <= 0) return "urgent";
  if (days <= 3) return "soon";
  return "later";
}

export function dateLabel(days) {
  if (days < 0) return `Périmé depuis ${Math.abs(days)} j`;
  if (days === 0) return "Aujourd'hui";
  if (days === 1) return "Demain";
  if (days <= 7) return `Dans ${days} j`;
  return `Dans ${Math.ceil(days / 7)} sem.`;
}

export const URGENCY_META = {
  urgent: {
    label: "À manger d'urgence",
    dot: "bg-destructive",
    border: "border-l-destructive",
    text: "text-destructive",
  },
  soon: {
    label: "Cette semaine",
    dot: "bg-warning",
    border: "border-l-warning",
    text: "text-[hsl(var(--warning))]",
  },
  later: {
    label: "Plus tard",
    dot: "bg-primary",
    border: "border-l-primary",
    text: "text-primary",
  },
};

export function formatEuro(n) {
  return (n || 0).toLocaleString("fr-FR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }) + "\u00A0€";
}
